import {MP_CREATE_PURCHASE_ORDER_COMPLETE, MP_READ_PURCHASE_ORDER_COMPLETE, MP_UPDATE_PURCHASE_ORDER_COMPLETE} from '../actions/actionTypes';
import initialState from './initialState';

export default function update(state = initialState.purchaseOrder, action) {
  if (action.type === MP_CREATE_PURCHASE_ORDER_COMPLETE) {
    return {
      ...state,
      headerId: action.payload.headerId
    };
  } else if (action.type === MP_READ_PURCHASE_ORDER_COMPLETE) {
    return {
      ...state,
      fetchedPurchaseOrder: action.payload.purchaseOrder
    };
  } else if (action.type === MP_UPDATE_PURCHASE_ORDER_COMPLETE) {
    return {
      ...state,
      updateResult: action.payload.result
    };
  } else {
    return state;
  }
}
